import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useSelector } from "react-redux";
import LottieAnimation from "../../Animations/LottieAnimation";
import { ToFirstCapital } from "../../Utils/helpers";
import "./settingsMain.css";


const SettingsMain = () => {

  const { admin } = useSelector((state) => state.admin || {});
  const currentRole = useSelector((state) => state?.admin?.admin?.data?.role)
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  const componentsList = [
    // "access_list",
    "country",
    "locality",
    "ranking",
    "categories",
    "collections",
    "currency",
    "amenities",
    "furnishing",
    "appointment_config",
    "config",
    "pages",
    "oora",
    "brands",
    "referral_Commission",
    "surrounding_Industries",
    // "notification",
    // "changePassword",
    "faq",
    "cab_Settings",
    "cabServiceProvider",
    "Finance_Partners",
    // "email_Templates",
    "cancellation_Policies",
    "fa_brands",
    "coming_soon_cities",
    "rating_review_panel"
  ];

  const permissionComponents = [];
  if (canAdd) {
    permissionComponents.push("notification", "email_Templates", "email", 'agent_profit_ranges');
  }

  const superAdminExclusive = currentRole === 'super_admin' ? ["access_list"] : [];


  const finalComponentsList = [...superAdminExclusive, ...componentsList, ...permissionComponents];

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleClick = (clickedItem) => {
    window.location.href = `/${clickedItem}`;
  };

  const getDisplayName = (comp) => {
    if (comp === 'fa_brands') return 'Featured/Associated Brands';
    return ToFirstCapital(comp).replace(/[-_]/g, " ");
  };

  return (
    <div className="settings-main">
      {loading ? (
        <LottieAnimation />
      ) : (
        <MainLayout>
          <section className="settings-wrapper">
            <h1 className="settings-header">Settings Components</h1>
            <div className="cards-container">
              {finalComponentsList.map((comp) => (
                <div
                  key={comp}
                  className="card-item"
                  onClick={() => handleClick(comp)}
                  role="button"
                  tabIndex={0}
                  onKeyPress={(e) => {
                    if (e.key === "Enter" || e.key === " ") handleClick(comp);
                  }}
                >
                  {getDisplayName(comp)}
                </div>
              ))}
            </div>
          </section>
        </MainLayout>
      )}
    </div>
  );
};

export default SettingsMain;
